import React, { Component } from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import style from './styles.module.scss';
import styled from 'styled-components';
import DiamondSideDrawer from './../../components/DiamondSideDrawer';
import { history } from "./../../../../../App";
import Badge from '@material-ui/core/Badge';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import CurrencyMenu from "shared/components/CurrencyMenu";
import { withWidth, withStyles } from "@material-ui/core";

const CartButton = styled(({ className }) => <Link className={className} to="/diamonds/bag"><button /></Link>)`
margin-top: auto;
margin-bottom: auto;

button{
    width: 16.7px;
    height: 14.1px;
    background-repeat: no-repeat;
    border: none;
    padding: 13px;
    background-color: transparent;
    cursor: pointer;
    transition-duration: 1s;
    color: #b6b8bc;

    background-image: url(/images/bag.svg); 
    &:hover{
        background-image: url(/images/bag_hover.svg); 
    }
    &.selected{
        background-image: url(/images/bag_active.svg) !important; 
    }
}
`;

class SecondaryNav extends Component {
    state = {
        diamondsTab: false,
    }

    componentDidMount() {
        this.setState({ diamondsTab: this.props.value })
    }

    handleDiamondsTab(diamondsTab) {
        if (!diamondsTab) return;
        this.setState({ diamondsTab })
        history.push(`/diamonds/${diamondsTab}`);
    }

    render() {
        const { openDiamondSideDrawer, closeBag, favouritesCount = 0, compareCount = 0, onSubmit, sideDrawerProps = {}, authUser, fxrates = [], isAuthorised, width, onMobileFiltersClick } = this.props;
        const { diamondsTab } = this.state;

        const userCurrencies = authUser && authUser.Balances ? authUser.Balances.reduce((userBalances, balance) => {
            Object.keys(balance).forEach(ccyCode => {
                userBalances[ccyCode] = balance[ccyCode];
            })
            return userBalances;
        }, []) : []
        let currencies = Object.keys(userCurrencies);
        let defaultCurrency = '';

        const defaultFXRate = fxrates.find(c => c.default);
        if (defaultFXRate) {
            defaultCurrency = defaultFXRate.currency;
            currencies = fxrates.map(c => c.currency);
        }

        const isMobile = width === 'xs';

        return (<React.Fragment>
            <div className={style.secondaryNav}>
                <ToggleButtonGroup exclusive value={diamondsTab} variant="text" color="primary" onChange={(e, value) => this.handleDiamondsTab(value)}>
                    <ToggleButton value="all">All Diamonds</ToggleButton>

                    {!isMobile && <ToggleButton value="fav">
                        <Badge badgeContent={favouritesCount} color="primary" classes={{ badge: style.badge }}>
                            Favourite
                        </Badge>
                    </ToggleButton>}

                    {!isMobile && <ToggleButton value="compare">
                        <Badge badgeContent={compareCount} color="primary" classes={{ badge: style.badge }}>
                            Compare List
                            </Badge>
                    </ToggleButton>}

                </ToggleButtonGroup>

                {isMobile && <div style={{ marginLeft: 'auto', display: 'flex' }} onClick={() => onMobileFiltersClick()}><img alt="" src="/images/filters.svg" style={{ background: 'black', filter: 'invert(1)', height: 45, width: 'auto' }} /></div>}

                {!isMobile && <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 5 }}>
                    {currencies.length > 0 ? <CurrencyMenu currencies={currencies} defaultCurrency={defaultCurrency} disabled={!isAuthorised} /> : ''}
                    <CartButton />
                </div>}
            </div>

            <DiamondSideDrawer open={openDiamondSideDrawer} closeBag={closeBag} onSubmit={onSubmit} {...sideDrawerProps} />
        </React.Fragment >
        )
    }
}

export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
        compareCount: state.diamonds.compare.length,
        favouritesCount: state.diamonds.favourite.length,
        fxrates: state.site.fxrates,
    }),
)(withWidth()(SecondaryNav));